<template>
  <div class="container_bg">
    <b-card
      :img-src="item.imgUrl"
      img-alt="Card image"
      img-top
      v-for="item in lists"
      :key="item.id"
      class="card_common"
      @click="goPlay(item.title)"
    >
      <b-card-text>
        <b-row>
          <b-col cols="4" class="default_text">{{ item.title }}</b-col>
          <b-col cols="8" class="itemText">{{ item.text }}</b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      lists: [
        {
          id: 1,
          imgUrl: require("../../images/layer9.png"),
          title: "Rummy",
          text:
            "Rummy is amongst the most popular games in India. It’s easy, fun and packed with a healthy dose of challenge that will keep you coming back for more."
        }
        // {
        //   id: 2,
        //   imgUrl: require("../../images/layer10.png"),
        //   title: "LUDO",
        //   text:
        //     "Ludo is a strategy board game for two to four players, in which the players race their four tokens from start to finish according to the rolls of a single die. Like other cross and circle games, Ludo is derived from the Indian game Pachisi. The game and its variations are popular in many countries and under various names."
        // },
        // {
        //   id: 3,
        //   imgUrl: require("../../images/layer11.png"),
        //   title: "DOMINO",
        //   text:
        //     "Domino is the configuration of played tiles on the table. It starts with a single tile and typically grows in two opposite directions when players add matching tiles. In practice, players often play tiles at right angles when the line of play gets too close to the edge of the table."
        // }
      ]
    };
  },
  methods: {
    goPlay(title) {
      console.log("goPlay" + title);
      window.location.href = "https://cdn.matrixgames.fun/game/index.html";
    }
  }
};
</script>

<style scoped lang="less">
.container_bg {
  position: relative;
  width: 100%;
  padding: 6vw 10vw;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #c11013, #0b0139);
}
.default_text {
  font-family: Arial;
  color: #1877f2;
  font-size: 2vw;
  font-weight: 700;
}
.card_common {
  margin-bottom: 2vw;
  cursor: pointer;
}
.card_common:nth-child(3) {
  margin-bottom: 0;
}
.itemText {
  font-family: Arial;
  font-size: 1vw;
  text-align: justify;
}
@media (max-width: 991px) {
  .default_text {
    font-size: 3vw;
  }
}
@media (max-width: 800px) {
  .default_text {
    font-size: 4vw;
  }
}
@media (max-width: 600px) {
  .default_text {
    font-size: 4vw;
  }
}
@media (max-width: 460px) {
  .default_text {
    font-size: 4vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue